module.exports = __webpack_public_path__ + "media/oh-du-fröhliche.e6b1c5f7.mp3";